var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarDays(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.001,
    height: 14.859,
    viewBox: "0 0 13.001 14.859",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "calendar-days",
    d: "M4.411,1.857H8.59V.7A.7.7,0,0,1,9.983.7V1.857h1.161A1.858,1.858,0,0,1,13,3.715V13a1.859,1.859,0,0,1-1.857,1.857H1.857A1.858,1.858,0,0,1,0,13V3.715A1.857,1.857,0,0,1,1.857,1.857H3.018V.7A.7.7,0,0,1,4.411.7ZM1.393,7.2H3.715V5.572H1.393Zm0,1.393v1.857H3.715V8.59Zm3.715,0v1.857H7.894V8.59Zm4.179,0v1.857h2.322V8.59Zm2.322-3.018H9.287V7.2h2.322Zm0,6.269H9.287v1.625h1.857A.466.466,0,0,0,11.608,13Zm-3.715,0H5.108v1.625H7.894Zm-4.179,0H1.393V13a.465.465,0,0,0,.464.464H3.715ZM7.894,5.572H5.108V7.2H7.894Z",
    fill: "#005974"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDays);
export default __webpack_public_path__ + "static/media/calendar-days.59718f3d257f27617af5a95f659c791e.svg";
export { ForwardRef as ReactComponent };